import { useCallback, useState } from "react";

const STORAGE_PREFIX = "sc-state:";

const read = (key, fallback) => {
    try {
        const raw = window.sessionStorage.getItem(STORAGE_PREFIX + key);
        return raw === null ? fallback : JSON.parse(raw);
    } catch {
        return fallback;
    }
};

const write = (key, value) => {
    try {
        window.sessionStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
    } catch {
        // Storage can be unavailable (private mode); the value just isn't remembered.
    }
};

/**
 * useState that survives leaving the page and coming back (or a refresh) for the browser tab
 * session. Used for list paging so finishing an action on a record returns to the same page.
 */
export default function useSessionState(key, initialValue) {
    const [value, setValue] = useState(() => read(key, initialValue));

    const setAndRemember = useCallback(
        (next) => {
            setValue((prev) => {
                const resolved = typeof next === "function" ? next(prev) : next;
                write(key, resolved);
                return resolved;
            });
        },
        [key],
    );

    return [value, setAndRemember];
}
